
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TimeFrameItemProps } from ".";
import { loading, create } from "store/time-frame";
import { AppMessage } from "components";

interface ApiTimeFrameCreateInputProps extends Omit<TimeFrameItemProps, "id"> {
}

type ApiTimeFrameCreateOutputProps = OutputBaseProps<{ item: TimeFrameItemProps; }, ApiTimeFrameCreateInputProps>

export const apiTimeFrameCreate = async (data: ApiTimeFrameCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiTimeFrameCreateOutputProps>("/api/time-frame/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};